import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function ServiciosPorCategoria() {
    const navigate = useNavigate();

    const [categorias, setCategorias]       = useState([]);
    const [sinCategoria, setSinCategoria]   = useState(null);
    const [cargando, setCargando]           = useState(false);

    useEffect(() => {
        (async () => {
            try {
                setCargando(true);
                const res = await axios.post("/categorias-con-conteo-admin", {});
                const sorted = (res.data.categorias || []).sort((a, b) => (b.borrador + b.aprobado) - (a.borrador + a.aprobado));
                setCategorias(sorted);
                setSinCategoria(res.data.sinCategoria || null);
            } catch { setCategorias([]); }
            finally { setCargando(false); }
        })();
    }, []);

    return (
        <div className="container-fluid">
            <div className="pt-3 pb-2 mb-4 border-bottom">
                <h1 className="h2 text-dark mb-1">Categorías</h1>
                <p className="text-muted mb-0 small">Servicios registrados por categoría.</p>
            </div>

            {cargando ? (
                <div className="text-center py-5">
                    <span className="spinner-border text-primary" role="status" />
                </div>
            ) : (
                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3">
                    {categorias.map(c => {
                        const total = c.borrador + c.aprobado + c.revision + c.desaprobado;
                        return (
                            <div key={c.categoria} className="col">
                                <div
                                    className="card border-0 shadow-sm rounded-4 h-100"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate("/admin/categoria-servicios", { state: { params: { categoria: c } } })}
                                    onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 24px rgba(var(--negro-rgb), 0.10)"}
                                    onMouseLeave={e => e.currentTarget.style.boxShadow = ""}
                                >
                                    <div className="card-body py-3 px-4">
                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            {c.icono ? (
                                                <img src={c.icono} alt={c.categoria}
                                                    style={{ width: 32, height: 32, objectFit: "contain", opacity: 0.8 }} />
                                            ) : (
                                                <i className="bi bi-grid text-muted" style={{ fontSize: 24 }}></i>
                                            )}
                                            <div className="flex-grow-1 min-w-0">
                                                <p className="fw-semibold text-dark mb-0 text-truncate" style={{ fontSize: "0.9rem" }}>{c.categoria}</p>
                                                <p className="text-muted mb-0" style={{ fontSize: "0.75rem" }}>
                                                    {total === 0 ? "Sin servicios" : `${total} servicio${total !== 1 ? "s" : ""}`}
                                                </p>
                                            </div>
                                            <i className="bi bi-chevron-right text-muted flex-shrink-0" style={{ fontSize: 13 }}></i>
                                        </div>

                                        <div className="d-flex gap-2 flex-wrap">
                                            <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--gris-suave-rgb), 0.1)", color: "var(--gris-suave)", fontSize: "0.72rem" }}>
                                                Borrador: {c.borrador}
                                            </span>
                                            <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--verde-bootstrap-rgb), 0.1)", color: "var(--verde-bootstrap)", fontSize: "0.72rem" }}>
                                                Aprobado: {c.aprobado}
                                            </span>
                                            {c.revision > 0 && (
                                                <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--amarillo-warning-rgb), 0.15)", color: "var(--dorado-oscuro)", fontSize: "0.72rem" }}>
                                                    Revisión: {c.revision}
                                                </span>
                                            )}
                                            {c.desaprobado > 0 && (
                                                <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--rojo-error-rgb), 0.1)", color: "var(--rojo-error)", fontSize: "0.72rem" }}>
                                                    Desaprobado: {c.desaprobado}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                    {/* Tarjeta especial: servicios sin categoría */}
                    {sinCategoria && (sinCategoria.borrador + sinCategoria.aprobado + sinCategoria.revision + sinCategoria.desaprobado) > 0 && (() => {
                        const total = sinCategoria.borrador + sinCategoria.aprobado + sinCategoria.revision + sinCategoria.desaprobado;
                        return (
                            <div className="col">
                                <div
                                    className="card border-0 shadow-sm rounded-4 h-100"
                                    style={{ cursor: "pointer", borderLeft: "3px solid var(--dorado)" }}
                                    onClick={() => navigate("/admin/categoria-servicios", { state: { params: { categoria: { sinCategoria: true, categoria: null, icono: null } } } })}
                                    onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 24px rgba(var(--negro-rgb), 0.10)"}
                                    onMouseLeave={e => e.currentTarget.style.boxShadow = ""}
                                >
                                    <div className="card-body py-3 px-4">
                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            <div
                                                className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                                                style={{ width: 32, height: 32, background: "rgba(var(--amarillo-warning-rgb), 0.15)" }}
                                            >
                                                <i className="bi bi-question-circle" style={{ color: "var(--dorado)", fontSize: 18 }}></i>
                                            </div>
                                            <div className="flex-grow-1 min-w-0">
                                                <p className="fw-semibold text-dark mb-0" style={{ fontSize: "0.9rem" }}>Sin categoría</p>
                                                <p className="text-muted mb-0" style={{ fontSize: "0.75rem" }}>
                                                    {total} servicio{total !== 1 ? "s" : ""} sin categoría asignada
                                                </p>
                                            </div>
                                            <i className="bi bi-chevron-right text-muted flex-shrink-0" style={{ fontSize: 13 }}></i>
                                        </div>
                                        <div className="d-flex gap-2 flex-wrap">
                                            {sinCategoria.borrador > 0 && (
                                                <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--gris-suave-rgb), 0.1)", color: "var(--gris-suave)", fontSize: "0.72rem" }}>
                                                    Borrador: {sinCategoria.borrador}
                                                </span>
                                            )}
                                            {sinCategoria.aprobado > 0 && (
                                                <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--verde-bootstrap-rgb), 0.1)", color: "var(--verde-bootstrap)", fontSize: "0.72rem" }}>
                                                    Aprobado: {sinCategoria.aprobado}
                                                </span>
                                            )}
                                            {sinCategoria.revision > 0 && (
                                                <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--amarillo-warning-rgb), 0.15)", color: "var(--dorado-oscuro)", fontSize: "0.72rem" }}>
                                                    Revisión: {sinCategoria.revision}
                                                </span>
                                            )}
                                            {sinCategoria.desaprobado > 0 && (
                                                <span className="badge rounded-pill px-2 py-1" style={{ background: "rgba(var(--rojo-error-rgb), 0.1)", color: "var(--rojo-error)", fontSize: "0.72rem" }}>
                                                    Desaprobado: {sinCategoria.desaprobado}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })()}
                </div>
            )}
        </div>
    );
}

export default ServiciosPorCategoria;
